import { render } from "./PdtDesc.vue?vue&type=template&id=4988e4db&scoped=true"
import script from "./PdtDesc.vue?vue&type=script&lang=js"
export * from "./PdtDesc.vue?vue&type=script&lang=js"

import "./PdtDesc.vue?vue&type=style&index=0&id=4988e4db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4988e4db"]])

export default __exports__